export { default } from "./documentPreviewImage";
